import axios from 'axios';
import { AccountUser } from 'contexts/account/types/account-user.type';

// GET
// /ewosapi/v1/useradmin/User/current
export const getCurrentUser = async (): Promise<AccountUser> => {
  const res = await axios.get<AccountUser>(`/ewosapi/v1/useradmin/User/current`);
  return res.data;
};
